import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CompanyContextService } from '@pages/empresas/services/company-context.service';
import { OWN_SESSION_REQUEST } from './own-session.context';

export const companyContextInterceptor: HttpInterceptorFn = (req, next) => {
  // Una petición con sesión propia (tienda, móvil) nunca debe llevar la empresa seleccionada en el PANEL: si el mismo
  // navegador tiene ambas sesiones abiertas a la vez (M04/32) y el empleado tiene una empresa
  // elegida en el panel, esa X-Company-Id pisaría el companyId que el backend ya resuelve del
  // propio token de tienda (`ActorArgumentResolver` la usa como override sin importar la
  // superficie) — corrompería a qué empresa pertenece el carrito/checkout del visitante.
  if (req.context.get(OWN_SESSION_REQUEST)) {
    return next(req);
  }
  const companyContext = inject(CompanyContextService);
  const companyId = companyContext.getCompanyId();
  if (companyId === null) { return next(req); }
  return next(req.clone({ setHeaders: { 'X-Company-Id': String(companyId) } }));
};
